// local imports
import { PasswordInput, AsyncButton } from '../../atoms';

const ChangePasswordForm = ({ loading }) => {
  return (
    <div className="w-full">
      <PasswordInput
        id="password_id"
        className="mb-16"
        name="password"
        label="Yeni Parola"
        placeholder="Yeni parola"
        disabled={loading}
        maxLength={12}
      />

      <PasswordInput
        id="password_confirmation_id"
        name="password_confirmation"
        label="Yeni Parola Onay"
        placeholder="Yeni parola onay"
        disabled={loading}
        maxLength={12}
      />

      <AsyncButton
        icon="lock_open"
        text="Kaydet"
        loading={loading}
        color="secondary"
        className="w-full mx-auto mt-16"
      />
    </div>
  );
};

export default ChangePasswordForm;
